module.exports = __webpack_public_path__ + "static/img/about_img.bd95073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_img.png
// module id = NUQr
// module chunks = 13